export default function returnDisplayName(username, displayName) {
    if(displayName === '') {
        return username
    } else {
        return displayName
    }
}